import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './CtaBanner.css';

interface CtaBannerProps {
  onBooking: () => void;
}

export default function CtaBanner({ onBooking }: CtaBannerProps) {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="cta-banner relative py-32 md:py-40 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxury%20barbershop%20dark%20atmospheric%20background%20texture%20black%20abstract%20elegant%20premium%20grooming%20studio%20ambiance%20cinematic%20lighting%20dramatic%20shadows%20high%20contrast%20monochromatic%20minimal&width=1400&height=600&seq=cta-bg-02&orientation=landscape"
          alt=""
          className="w-full h-full object-cover cta-banner-bg"
        />
      </div>

      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />

      {/* Subtle metallic glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] pointer-events-none cta-banner-glow"
      />

      {/* Top/bottom lines */}
      <div className="absolute top-0 left-0 right-0 cta-banner-line" />
      <div className="absolute bottom-0 left-0 right-0 cta-banner-line" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <p
          className={`cta-banner-label mb-6 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          ◆ Reserva Tu Cita ◆
        </p>

        <h2
          className={`cta-banner-title mb-6 transition-all duration-700 delay-100 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          Reserva tu cita
          <br />
          <span className="cta-banner-title-accent">
            ahora
          </span>
        </h2>

        <p
          className={`cta-banner-subtitle transition-all duration-700 delay-200 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          Sin esperas. Sin complicaciones. Tu próxima transformación está a un clic.
        </p>

        <div
          className={`flex flex-col sm:flex-row gap-4 items-center justify-center transition-all duration-700 delay-300 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <Link
            to="/reservar"
            className="cta-banner-btn cursor-pointer"
          >
            Agendar
            <div className="cta-banner-btn-icon">
              <i className="ri-arrow-right-line" />
            </div>
          </Link>
          <p className="cta-banner-note">
            Confirmación inmediata · Sin compromiso
          </p>
        </div>
      </div>
    </section>
  );
}